import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Tag } from 'antd';
import React, { use, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TestCaseList from './TestCaseList';
import { testCaseDifficultyMap } from './QuestionTab';
import styles from './QuestionTab.scss';

const QuestionDetails = ({
  question,
  testCases,
  onClose,
  tags,
  onAddQuestionTab,
  isAlreadyAdded,
}) => {
  const { t } = useTranslation('interview_container');

  let count = 0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hideQuestion, setHideQuestion] = useState(true);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    onAddQuestionTab(question, hideQuestion);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setHideQuestion(true);
  }, [question]);
  const data = question.description
    ? question.description.split('\n').map(function (line) {
        if (
          line.includes('Input format') ||
          line.includes('Output format') ||
          line.includes('Constraints')
        ) {
          return (
            <div
              key={count++}
              className={styles['desc-style']}
            >
              {line}
            </div>
          );
        } else if (
          line.includes('Input:') ||
          line.includes('Output:') ||
          line.includes('Explanation:')
        ) {
          // srb remove them later
          return (
            <div
              key={count++}
              className={styles['desc-style']}
            >
              {line}
            </div>
          );
        } else {
          return (
            <div
              key={count++}
              className={styles['contentstyle']}
            >
              {line}
            </div>
          );
        }
      })
    : t('question_details.please_select_problem');
  return (
    <div
      style={{
        padding: 20,
        background: 'white',
        height: '70vh',
        overflowY: 'scroll',
        margin: 10,
        border: '1px solid #E6E6E6',
        boxShadow: '0px 0px 10px 0px #0000001A',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: 12 }}>
          <p>
            {question.points} {t('question_details.points')}
          </p>
          <Tag style={{ height: 22 }}>
            {t('question_details.difficulty')}: {testCaseDifficultyMap[question.difficulty]}
          </Tag>
        </div>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          style={{ float: 'right' }}
        />
      </div>

      <div style={{ display: 'flex', marginTop: 20, justifyContent: 'space-between' }}>
        <h1 style={{ fontWeight: 500 }}>{question.title}</h1>
        <Button
          type="primary"
          onClick={showModal}
          disabled={isAlreadyAdded}
        >
          {t('question_details.add_to_interview')}
          {isAlreadyAdded
            ? t('question_details.added_already')
            : t('question_details.add_to_interview_button')}
        </Button>
      </div>
      <Modal
        title={
          <p style={{ fontSize: 24, textAlign: 'center' }}>
            {t('question_details.add_to_interview')}
          </p>
        }
        centered
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <div
            key="footer"
            style={{ textAlign: 'center' }}
          >
            <Button
              key="cancel"
              onClick={handleCancel}
              style={{ marginRight: 8 }}
            >
              {t('question_details.no')}
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={handleOk}
            >
              {t('question_details.yes')}
            </Button>
          </div>,
        ]}
      >
        <p style={{ textAlign: 'center' }}>{t('question_details.confirm_add_question')}</p>
        <label
          style={{
            display: 'flex',
            margin: '-4px',
            marginTop: '4px',
            gap: 6,
            justifyContent: 'center',
          }}
        >
          <input
            type="checkbox"
            checked={hideQuestion}
            onChange={e => {
              setHideQuestion(e.target.checked);
            }}
          />
          {t('question_details.hide_question_from_candidate')}
        </label>
      </Modal>
      <div style={{ margin: '8px 0' }}>{data}</div>
      {testCases?.length > 0 && (
        <div className={styles['question-tab__testcases']}>
          <h3 className={styles['question-tab__desc']}>{t('question_details.test_cases')}:</h3>
          <TestCaseList testCases={testCases} />
        </div>
      )}
    </div>
  );
};

export default QuestionDetails;
